import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { Modal, Form, Button } from 'antd';

import ConsumableReportForm from '../ConsumableReportForm';
import { ModalProps } from '@/types/ModalProps';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import {
  OrderByColumnReport,
  ReportConsumablesFormValues,
  ReportConsumablesParams,
} from '@/core/domain/reports/stock/Report.types';
import { useGenerateConsumablesReport } from '@/core/domain/reports/stock/Report.hooks';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import { useReportGenerate } from '@/hooks';
import { ReportCallback } from '@/hooks/useReportGenerate';

function ConsumableReportModal({ visible, handleVisible }: ModalProps) {
  const intl = useIntl();

  const [form] = Form.useForm<ReportConsumablesFormValues>();

  const mutation = useGenerateConsumablesReport();
  const { fileLoading, setFileLoading, setFileUnloading, FILE_FORMAT } =
    useFileLoading();
  const report = useReportGenerate();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);
    try {
      const values = await form.validateFields();

      const obj: ReportConsumablesParams = {
        ...values,
        format: FILE_FORMAT[format],
        manufacturer: values.manufacturer
          ? String(values.manufacturer)
          : undefined,
        companies: values.companies ? String(values.companies) : undefined,
        groups: values.groups,
        //TODO: Solicitado remoção na UL-2950
        // orderByColumn: values.orderByColumn,
        orderByColumn: OrderByColumnReport.description,
      };

      const result = await mutation.mutateAsync(obj);

      if (callback) {
        callback(result);
      }

      handleVisible();

      form.resetFields();
    } catch {}
    setFileUnloading(format);
  };

  return (
    <Modal
      width={750}
      open={visible}
      onCancel={handleVisible}
      title={intl.formatMessage({ id: 'customers.modal.report.title' })}
      footer={
        <SpaceForButton justifyContent="flex-end">
          <Button
            block
            type="primary"
            onClick={() =>
              handleGenerateReport('REPORT_VIEW', (result) =>
                report.openFile({
                  result,
                  fileName: 'insumos.pdf',
                  fileType: 'application/pdf',
                }),
              )
            }
            key="viewReport"
            loading={fileLoading.REPORT_VIEW}
          >
            <FormattedMessage id="customers.modal.report.buttons.viewReport" />
          </Button>
          <Button
            block
            type="primary"
            key="PDF"
            onClick={() =>
              handleGenerateReport('PDF', (result) =>
                report.downloadFile({ result, fileName: 'insumos.pdf' }),
              )
            }
            loading={fileLoading.PDF}
          >
            <FormattedMessage id="customers.modal.report.buttons.pdf" />
          </Button>
          <Button
            block
            type="primary"
            key="CSV"
            onClick={() =>
              handleGenerateReport('CSV', (result) =>
                report.downloadFile({ result, fileName: 'insumos.csv' }),
              )
            }
            loading={fileLoading.CSV}
          >
            <FormattedMessage id="customers.modal.report.buttons.csv" />
          </Button>
        </SpaceForButton>
      }
    >
      <ConsumableReportForm form={form} />
    </Modal>
  );
}

export default ConsumableReportModal;
